import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { toast } from "sonner";

import { hangHoaApi } from "src/1/apis/hang_hoa.api";
import { history } from "src/App";

import { DieuChinhGiaForm } from "../../components";

const defaultValues = {
  adjustment_note: "",
  menu_ids: [],
  goods: [{ code: "", new_price: 0, new_holiday_price: 0 }],
};

export default function FormYeuCauDieuChinhGia() {
  //#region Data
  const {
    control,
    handleSubmit,
    formState: { isSubmitting },
    reset,
  } = useForm({
    defaultValues,
  });

  const params = useParams();

  const { data } = useQuery({
    queryKey: ["chi-tiet-yeu-cau-dieu-chinh-gia", params?.id],
    queryFn: () => hangHoaApi.getChangePriceById(params.id),
    enabled: !!params?.id,
    select: (response) => response?.data?.data,
  });
  //#endregion

  useEffect(() => {
    if (data) {
      reset({
        adjustment_note: data?.adjustment_note,
        menu_ids: (data?.menu_list || []).map((e) => e.menu_id),
        goods: (data?.goods_list || []).map((e) => ({
          code: e.code,
          price: e.price,
          holiday_price: e.holiday_price,
          new_price: e.new_price,
          new_holiday_price: e.new_holiday_price,
        })),
      });
    }
  }, [data]);

  //#region Event
  const onSubmit = handleSubmit(async (values) => {
    try {
      await hangHoaApi.createChangePrice(values);
      toast.success("Tạo đề xuất thay đổi giá thành công!");
      history.push("/menus/change-price/list");
    } catch (error) {
      toast.error(error?.message || "Lưu thông tin không thành công");
    }
  });
  //#endregion

  //#region Render
  return (
    <>
      <DieuChinhGiaForm
        onSubmit={onSubmit}
        isSubmitting={isSubmitting}
        control={control}
        data={data}
      />
    </>
  );
  //#endregion
}
